<template>
  <v-sheet
    :dark="$theme.dark"
    :light="$theme.light"
    class="expande-horizontal sheet-container pt-2"
  >
    <v-flex xs12 class="pr-1">
      <Filters :filter="filter" />
      <!-- <sale :filtereds="filtereds" /> -->
      <List :filtereds="filtereds" />
      <EmptyList
        v-if="filtereds.length === 0"
      />
    </v-flex>
  </v-sheet>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
// import sale from "../components/sale.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      filter: {},
      options: [
        // {
        //   nome: "Novo sale",
        //   action: this.iniciarCadastro,
        //   icon: "mdi-plus"
        // }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "Vendas",
          path: "/sales"
        }
      ]
    };
  },
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm,
    // sale
  },
  computed: {
    ...mapGetters([
      "get_sales_filtros",
      "getLoggedUser",
      "get_sale",
      "get_sales",
      "getPersonalizedLoading"
    ]),
    filtereds() {
      if (this.filter.search) {
        return this.get_sales.docs.filter(item => {
          return (
            (item.nome &&
              item.nome
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.email &&
              item.email
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.telefone &&
              item.telefone.includes(this.filter.search.toLowerCase()))
          );
        });
      } else {
        return this.get_sales.docs;
      }
    }
  },
  methods: {
    excluir_sale_dialog(item) {
      let text = "Deseja remover este sale?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_sale",
        action_value: item
      });
    },
    ...mapActions([
      "list_sales",
      "setPersonalizedLoading",
      "createConfirmAction"
    ]),
  },
  created() {
    this.list_sales();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
</style>
